import type {
  AssistantsResponse,
  ChatPayload,
  ChatResponse,
  SendResponse,
} from '@/types/chat'
import axios from 'axios'

const assistantsApiCall = async (
  abortController?: AbortController,
): Promise<AssistantsResponse> => {
  const { data } = await axios.get('/ai/assistants', {
    signal: abortController?.signal,
  })
  return data
}

const chatApiCall = async (
  abortController?: AbortController,
  params?: ChatPayload,
): Promise<ChatResponse> => {
  const { data } = await axios.get('/ai/chat', {
    signal: abortController?.signal,
    params,
  })
  return data.data
}

const sendChatApiCall = async (
  abortController?: AbortController,
  params?: any,
): Promise<SendResponse> => {
  const { data } = await axios.post(
    '/ai/chat/send',
    params,
    { signal: abortController?.signal },
  )
  return data.data
}

const clearChatApiCall = async (
  abortController?: AbortController,
  params?: any,
): Promise<SendResponse> => {
  const { data } = await axios.post(
    '/ai/chat/history',
    params,
    { signal: abortController?.signal },
  )
  return data.data
}

export {
  assistantsApiCall,
  chatApiCall,
  clearChatApiCall,
  sendChatApiCall,
}
